import React, { useState, useEffect } from 'react';
import { Row, Col, Label, Form, Card, CardBody } from 'reactstrap';
import { useForm } from 'react-hook-form';

const EventDayFeedbackFormV2 = ({ formSubmit, onPrevious, data }) => {
    const {
        register,
        formState: { errors },
        watch,
        handleSubmit,
        getValues,
        setValue
    } = useForm({
        mode: "onBlur",
    });

    const fields = [
        "number_of_categories",
        "resource_available_on_time",
        "judge_quality_score",
        "website_updated_on_time",
        "shortlist_format_correct",
        "linked_in_announcement_posted",
        "negative_feedback",
        "negative_feedback_text_yes",
        "campaign_time_optimal_for_entries",
        "campaign_time_optimal_for_entries_improvement",
    ];

    const [campaignTimeOptimalForEntriesImprovement, setCampaignTimeOptimalForEntriesImprovement] = useState({ required: false });
    const [perceptionConstructiveOrNegativeFeedbackText, setPerceptionConstructiveOrNegativeFeedbackText] = useState({ required: false });

    const submit = (response) => {
        formSubmit(response);
    }

    const previous = (e) => {
        e.preventDefault();
        const data = getValues();
        onPrevious(data);
    }

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            const getValuesConditions = {
                "campaign_time_optimal_for_entries": (value) => setCampaignTimeOptimalForEntriesImprovement(value),
                
            };

            const getValuesConditionsYes = {
                "negative_feedback": (value) => setPerceptionConstructiveOrNegativeFeedbackText(value), 
            };

            Object.keys(getValuesConditionsYes).map(key => {
                if (getValues(key) === "Yes")
                    getValuesConditionsYes[key]({ required: 'Required!' });
                else
                    getValuesConditionsYes[key]({ required: false });
            });

            Object.keys(getValuesConditions).map(key => {
                if (getValues(key) === "No")
                    getValuesConditions[key]({ required: 'Required!' });
                else
                    getValuesConditions[key]({ required: false });
            });

        })
        return () => subscription.unsubscribe()
    }, [watch]);

    useEffect(() => {
        fields.map(field => setValue(field, data[field]));
    }, []);

    return (
        <Form onSubmit={handleSubmit(submit)}>

            <Card className="mb-4">
                <CardBody className="pb-3">
                    <Label className='my-1' style={{ fontWeight: '600' }}>
                        Entry Process
                    </Label>
                    <br />

                    {/* number_of_categories */}
                    <div>
                        <Label className='my-2'>
                            How many new categories were introduced? <span className="asterisk_red">*</span>
                        </Label>
                        <input
                            type="number"
                            {...register("number_of_categories", {
                                required: "This field is required",
                                min: {
                                    value: 1,
                                    message: "Minimum is 1"
                                },
                            })}
                            className={`form-control ${errors.number_of_categories ? "form-invalid mb-0" : "mb-0"}`}
                        />
                        {errors.number_of_categories ? <p role="alert" className="invalid-feedback mb-0">{errors.number_of_categories.message}</p> : null}
                    </div>

                    {/* resource_available_on_time */}
                    <div>
                        <Label className='mb-2 mt-4'>
                            Were all resources available on time? <span className="asterisk_red">*</span>
                        </Label>
                        <p className='mb-2 d-flex align-items-center'>
                            <input
                                id="resource_available_on_time_yes"
                                type='radio'
                                {...register("resource_available_on_time", {
                                    required: 'Required',
                                })}
                                value="Yes"
                                className='mr-2 cursor-pointer'
                            />
                            <Label className="font-weight-normal mb-0 cursor-pointer" htmlFor="resource_available_on_time_yes">Yes</Label>
                        </p>
                        <p className='mb-2 d-flex align-items-center'>
                            <input
                                id="resource_available_on_time_no"
                                type='radio'
                                {...register("resource_available_on_time", {
                                    required: 'Required',
                                })}
                                value="No"
                                className='mr-2 cursor-pointer'
                            />
                            <Label className="font-weight-normal mb-0 cursor-pointer" htmlFor="resource_available_on_time_no">
                                No 
                            </Label>
                        </p>
                        {errors.resource_available_on_time ? <p role="alert" className="invalid-feedback mb-0">{errors.resource_available_on_time.message}</p> : null}
                    </div>

                    {/* judge_quality_score */}
                    <div>
                        <Label className='mb-2 mt-4'>
                            Were judges of good enough standard? <span className="asterisk_red">*</span>
                        </Label>
                        <p className='mb-2 d-flex align-items-center'>
                            <input
                                id="judge_quality_score_yes"
                                type='radio'
                                {...register("judge_quality_score", {
                                    required: 'Required',
                                })}
                                value="Yes"
                                className='mr-2 cursor-pointer'
                            />
                            <Label className="font-weight-normal mb-0 cursor-pointer" htmlFor="judge_quality_score_yes">Yes</Label>
                        </p>
                        <p className='mb-2 d-flex align-items-center'>
                            <input
                                id="judge_quality_score_no"
                                type='radio'
                                {...register("judge_quality_score", {
                                    required: 'Required',
                                })}
                                value="No"
                                className='mr-2 cursor-pointer'
                            />
                            <Label className="font-weight-normal mb-0 cursor-pointer" htmlFor="judge_quality_score_no">
                                No 
                            </Label>
                        </p>
                        {errors.judge_quality_score ? <p role="alert" className="invalid-feedback mb-0">{errors.judge_quality_score.message}</p> : null}
                    </div>
                </CardBody>
            </Card>

            <Card className="mb-4">
                <CardBody className="pb-3">
                    <Label className='my-1' style={{ fontWeight: '600' }}>
                        Communication
                    </Label>
                    <br />

                    {/* website_updated_on_time */}
                    <div>
                        <Label className='my-2'>
                            Was the website updated on time? <span className="asterisk_red">*</span>
                        </Label>
                        <p className='mb-2 d-flex align-items-center'>
                            <input
                                id="website_updated_on_time_yes"
                                type='radio'
                                {...register("website_updated_on_time", {
                                    required: 'Required',
                                })}
                                value="Yes"
                                className='mr-2 cursor-pointer'
                            />
                            <Label className="font-weight-normal mb-0 cursor-pointer" htmlFor="website_updated_on_time_yes">Yes</Label>
                        </p>
                        <p className='mb-2 d-flex align-items-center'>
                            <input
                                id="website_updated_on_time_no"
                                type='radio'
                                {...register("website_updated_on_time", {
                                    required: 'Required',
                                })}
                                value="No"
                                className='mr-2 cursor-pointer'
                            />
                            <Label className="font-weight-normal mb-0 cursor-pointer" htmlFor="website_updated_on_time_no">
                                No 
                            </Label>
                        </p>
                        {errors.website_updated_on_time ? <p role="alert" className="invalid-feedback mb-0">{errors.website_updated_on_time.message}</p> : null}
                    </div>

                    {/* shortlist_format_correct */}
                    <div>
                        <Label className='mb-2 mt-4'>
                            Was the shortlist format all correct (relevant imagery, project title etc)? <span className="asterisk_red">*</span>
                        </Label>
                        <p className='mb-2 d-flex align-items-center'>
                            <input
                                id="shortlist_format_correct_yes"
                                type='radio'
                                {...register("shortlist_format_correct", {
                                    required: 'Required',
                                })}
                                value="Yes"
                                className='mr-2 cursor-pointer'
                            />
                            <Label className="font-weight-normal mb-0 cursor-pointer" htmlFor="shortlist_format_correct_yes">Yes</Label>
                        </p>
                        <p className='mb-2 d-flex align-items-center'>
                            <input
                                id="shortlist_format_correct_no"
                                type='radio'
                                {...register("shortlist_format_correct", {
                                    required: 'Required',
                                })}
                                value="No"
                                className='mr-2 cursor-pointer'
                            />
                            <Label className="font-weight-normal mb-0 cursor-pointer" htmlFor="shortlist_format_correct_no">
                                No 
                            </Label>
                        </p>
                        {errors.shortlist_format_correct ? <p role="alert" className="invalid-feedback mb-0">{errors.shortlist_format_correct.message}</p> : null}
                    </div>

                    {/* linked_in_announcement_posted */}
                    <div>
                        <Label className='mb-2 mt-4'>
                            Was the Leader / Outstanding Contribution Recipient announced on LinkedIn? <span className="asterisk_red">*</span>
                        </Label>
                        <p className='mb-2 d-flex align-items-center'>
                            <input
                                id="linked_in_announcement_posted_yes"
                                type='radio'
                                {...register("linked_in_announcement_posted", {
                                    required: 'Required',
                                })}
                                value="Yes"
                                className='mr-2 cursor-pointer'
                            />
                            <Label className="font-weight-normal mb-0 cursor-pointer" htmlFor="linked_in_announcement_posted_yes">Yes</Label>
                        </p>
                        <p className='mb-2 d-flex align-items-center'>
                            <input
                                id="linked_in_announcement_posted_no"
                                type='radio'
                                {...register("linked_in_announcement_posted", {
                                    required: 'Required',
                                })}
                                value="No"
                                className='mr-2 cursor-pointer'
                            />
                            <Label className="font-weight-normal mb-0 cursor-pointer" htmlFor="linked_in_announcement_posted_no">
                                No 
                            </Label>
                        </p>
                        {errors.linked_in_announcement_posted ? <p role="alert" className="invalid-feedback mb-0">{errors.linked_in_announcement_posted.message}</p> : null}
                    </div>
                </CardBody>
            </Card>

            <Card className="mb-4">
                <CardBody className="pb-3">
                    <Label className='my-1' style={{ fontWeight: '600' }}>
                        Perception
                    </Label>
                    <br />

                    {/* negative_feedback */}
                    <div>
                        <Label className='my-2'>
                            Was there any constructive or negative feedback given? <span className="asterisk_red">*</span>
                        </Label>
                        <p className='mb-2 d-flex align-items-center'>
                            <input
                                id="negative_feedback_yes"
                                type='radio'
                                {...register("negative_feedback", {
                                    required: 'Required',
                                })}
                                value="Yes"
                                className='mr-2 cursor-pointer'
                            />
                            <Label className="font-weight-normal mb-0 cursor-pointer" htmlFor="negative_feedback_yes">Yes</Label>
                        </p>
                        <p className='mb-2 d-flex align-items-center'>
                            <input
                                id="negative_feedback_no"
                                type='radio'
                                {...register("negative_feedback", {
                                    required: 'Required',
                                })}
                                value="No"
                                className='mr-2 cursor-pointer'
                            />
                            <Label className="font-weight-normal mb-0 cursor-pointer" htmlFor="negative_feedback_no">
                                No 
                            </Label>
                        </p>
                        {errors.negative_feedback ? <p role="alert" className="invalid-feedback mb-0">{errors.negative_feedback.message}</p> : null}
                        <Label className='my-2'>
                            If yes, provide details about the constructive or negative feedback.&nbsp;
                            {perceptionConstructiveOrNegativeFeedbackText.required === "Required!" && (<span className="asterisk_red">*</span>)}
                        </Label>
                        <textarea
                            {...register("negative_feedback_text_yes", {
                                ...perceptionConstructiveOrNegativeFeedbackText
                            })}
                            className={`form-control ${errors.negative_feedback_text_yes ? "form-invalid mb-0" : "mb-0"}`}
                        />
                        {errors.negative_feedback_text_yes ? <p role="alert" className="invalid-feedback mb-0">{errors.negative_feedback_text_yes.message}</p> : null}
                    </div>

                    {/* campaign_time_optimal_for_entries */}
                    <div>
                        <Label className='mb-2 mt-4'>
                            Was the time of the campaign optimum for entries? <span className="asterisk_red">*</span>
                        </Label>
                        <p className='mb-2 d-flex align-items-center'>
                            <input
                                id="campaign_time_optimal_for_entries_yes"
                                type='radio'
                                {...register("campaign_time_optimal_for_entries", {
                                    required: 'Required',
                                })}
                                value="Yes"
                                className='mr-2 cursor-pointer'
                            />
                            <Label className="font-weight-normal mb-0 cursor-pointer" htmlFor="campaign_time_optimal_for_entries_yes">Yes</Label>
                        </p>
                        <p className='mb-2 d-flex align-items-center'>
                            <input
                                id="campaign_time_optimal_for_entries_no"
                                type='radio'
                                {...register("campaign_time_optimal_for_entries", {
                                    required: 'This field is required',
                                })}
                                value="No"
                                className='mr-2 cursor-pointer'
                            />
                            <Label className="font-weight-normal mb-0 cursor-pointer" htmlFor="campaign_time_optimal_for_entries_no">
                                No 
                            </Label>
                        </p>
                        {errors.campaign_time_optimal_for_entries ? <p role="alert" className="invalid-feedback mb-0">{errors.campaign_time_optimal_for_entries.message}</p> : null}

                        <Label className='my-2'>
                            If no, why not?&nbsp;
                            {campaignTimeOptimalForEntriesImprovement.required === "Required!" && (<span className="asterisk_red">*</span>)}
                        </Label>
                        <textarea
                            {...register("campaign_time_optimal_for_entries_improvement", {
                                ...campaignTimeOptimalForEntriesImprovement
                            })}
                            className={`form-control ${errors.campaign_time_optimal_for_entries_improvement ? "form-invalid mb-0" : "mb-0"}`}
                        />
                        {errors.campaign_time_optimal_for_entries_improvement ? <p role="alert" className="invalid-feedback mb-0">{errors.campaign_time_optimal_for_entries_improvement.message}</p> : null}
                    </div>
                </CardBody>
            </Card>

            <Row>
                <Col md="6" className="text-left mt-3">
                    <button className="form-btn inline-block w-75 newbuttontheme text-white" onClick={previous}>PREVIOUS</button>
                </Col>
                <Col md="6" className="text-right mt-3">
                    <button className="form-btn inline-block w-50 newbuttontheme text-white submit-btn" type="submit">NEXT</button>
                </Col>
            </Row>
        </Form>
    )
}

export default EventDayFeedbackFormV2;